var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "active-global-container" },
    [
      _c("FreeModal"),
      _c("CampaignModal"),
      _c("PostSuccessModal"),
      _c("BindCardModal"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }